import { type JobInfoDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto';
import { atom } from 'recoil';
import { jobInfoSelector } from '../selectors/jobInfoSelector';

export const jobInfoAtom = atom<JobInfoDTO>({
    key: 'jobInfoAtom',
    default: jobInfoSelector
});
